import { ActivatedRoute } from '@angular/router';
import { GuardianService } from './../../_services/guardian.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-guardian-student',
  templateUrl: './report-guardian-student.component.html',
  styleUrls: ['./report-guardian-student.component.css']
})
export class ReportGuardianStudentComponent implements OnInit {
  loading=false
  server_user_id=0
  student_user_id=0
  ppReport ={}
  constructor(
    private guardianService: GuardianService, private route:ActivatedRoute) {

  }
  ngOnInit(): void {
        this.loading=true
        this.route.params.subscribe(
          params=>{
            this.server_user_id = +params['server_user_id']

            this.student_user_id = +params['student_user_id']
            if (this.server_user_id!=0) {
              this.guardianService.getStudentReportsById(this.student_user_id).subscribe(
                x => {
                  this.ppReport=x

                  this.loading=false
                })
            }

          }
        )

  }


}
